import { render, staticRenderFns } from "./OrderReceptionBoxWidget.vue?vue&type=template&id=53e6d07d"
import script from "./OrderReceptionBoxWidget.vue?vue&type=script&lang=js"
export * from "./OrderReceptionBoxWidget.vue?vue&type=script&lang=js"
import style0 from "./OrderReceptionBoxWidget.vue?vue&type=style&index=0&id=53e6d07d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports